import { AllocationViewSelectedEntityModel, AllocationViewLeadUliModel } from '../models';

export class AllocationViewSetActionIdentifier {
  public static readonly type = '[AllocationViewActions] Set Action Identifier';

  constructor(public payload: AllocationViewSelectedEntityModel) {}
}

export class AllocationViewSetLeadUlis {
  public static readonly type = '[AllocationViewActions] Set Lead Ulis';

  constructor(public payload: AllocationViewLeadUliModel[]) {}
}

export class AllocationViewActionsInitialState {
  public static readonly type = '[AllocationViewActions] Set Initial State';
}

export class AllocationViewActionsCloseActionContainer {
  public static readonly type = '[AllocationViewActions] Close Action Container';

  constructor(public payload: boolean = true) {}
}

export class AllocationViewActionsShouldUpdate {
  public static readonly type = '[AllocationViewActions] Should Update';

  constructor(public payload: boolean = true) {}
}
